import { render, staticRenderFns } from "./TasksCalendar.vue?vue&type=template&id=effd60fe&scoped=true"
import script from "./TasksCalendar.vue?vue&type=script&lang=ts"
export * from "./TasksCalendar.vue?vue&type=script&lang=ts"
import style0 from "./TasksCalendar.vue?vue&type=style&index=0&id=effd60fe&prod&lang=scss&scoped=true"
import style1 from "./TasksCalendar.vue?vue&type=style&index=1&id=effd60fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd60fe",
  null
  
)

export default component.exports